export const batchNameFormat = (name = "") => {
  if(name === null)
    return "";

  const nameArray = name.split(".");
  return nameArray[1] === "0" ? nameArray[0] : name;
};
